export default "__VITE_ASSET__CRxBULRS__"